import { useLocalStorage } from 'react-use';
import { v4 as uuidv4 } from 'uuid';

// Add/Remove/Fetch features/geometries from local storage.
const useFavourites = (): any[] => {
    const [favourites, setFavourites] = useLocalStorage<any>(
        'iaoAreaSelectionFavourites',
        {}
    );
    const addFeature = ({
        label,
        ids,
        layerUrl,
        layerLabel
    }: {
        layerUrl: string;
        layerLabel: string;
        label: string;
        ids: string[];
    }) => {
        const id = uuidv4();
        const fav = {
            label,
            ids,
            layer: { label: layerLabel, url: layerUrl }
        };
        const favs =
            favourites !== undefined
                ? { [id]: fav, ...favourites }
                : { [id]: fav };
        setFavourites(favs);
    };
    const addSelector = ({
        label,
        tool,
        geometry
    }: {
        label: string;
        tool: string;
        geometry: string;
    }) => {
        const id = uuidv4();
        const fav = { label, tool, geometry };
        const favs =
            favourites !== undefined
                ? { [id]: fav, ...favourites }
                : { [id]: fav };
        setFavourites(favs);
    };
    const remove = (id: string) => {
        const favs = { ...favourites };
        delete favs[id];
        setFavourites(favs);
    };
    return [favourites ?? {}, addFeature, addSelector, remove];
};
export default useFavourites;
